<template>
  <BuyZESACTA
    :zesaunits="zesaunits"
    @brokenarrow="sayBrokenArrow"
    @showzesacta="doShowZESACTA"
    @hidezesacta="hideZESACTA"
    :showZESACTA="showZESACTA"
  />
</template>

<script>
import BuyZESACTA from "./BuyZESACTA.vue";
export default {
  name: "BuyZESA",
  emits: ["brokenarrow"],
  props: ["zesaunits"],
  components: { BuyZESACTA },
  data() {
    return { showZESACTA: false };
  },
  methods: {
    sayBrokenArrow() {
      this.$emit("brokenarrow");
    },
    hideZESACTA() {
      this.showZESACTA = false;
    },
    doShowZESACTA() {
      this.showZESACTA = true;
    },
  },
  mounted() {
    //Sliently get the exchange rates here
  },
};
</script>

<style></style>
